"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchOrgService = void 0;
const tslib_1 = require("tslib");
const _1 = require(".");
class SearchOrgService {
    constructor() {
        this.__priority = 50;
        this.query = { text: 'test' };
    }
    sendQuery(str) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.query.text = str;
            const rest = _1.Services.Department.rest;
            return (yield rest.action('org.search', this.query)).results;
        });
    }
}
exports.SearchOrgService = SearchOrgService;
//# sourceMappingURL=search.org.service.js.map